import styled from 'styled-components';

const PageWrapper = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 100vh;
`;

export default PageWrapper;
